export default __webpack_public_path__ + "static/media/p20.095b59d9.jpg";